import dayjs from "dayjs";
import { AiFillBehanceCircle } from "react-icons/ai";

const listSelectBase = (t) => [
  {
    label: `${t("All")}`,
    value: null,
  },
];

const sequenceMode = {
  0: "Không Reset",
  1: "Theo Ngày",
  2: "Theo Tháng",
  3: "Theo Năm",
};

const sequenceModeText = {
  "Không Reset": 0,
  "Theo Ngày": 1,
  "Theo Tháng": 2,
  "Theo Năm": 3,
};

const sequenceComboBox = [
  {
    label: "Không Reset",
    value: 0,
  },
  {
    label: "Theo Ngày",
    value: 1,
  },
  {
    label: "Theo Tháng",
    value: 2,
  },
  {
    label: "Theo Năm",
    value: 3,
  },
];

const type = [
  {
    label: "Thường quy",
    value: true,
  },
  {
    label: "Vi sinh đặc biệt",
    value: false,
  },
];

const typeForm = {
  text: "text",
  textarea: "textarea",
  number: "number",
  datepicker: "datepicker",
  dateTimePicker: "dateTimePicker",
  select: "select",
  checkbox: "checkbox",
  colorpicker: "colorpicker",
  custom: "custom",
  file: "file",
  multiselect: "multiselect",
  password: "password",
};

const typeFormSelect = [
  {
    value: "text",
    label: "text",
  },
  {
    value: "textarea",
    label: "textarea",
  },
  {
    value: "number",
    label: "number",
  },
  {
    value: "datepicker",
    label: "datepicker",
  },
  {
    value: "dateTimePicker",
    label: "dateTimePicker",
  },
  {
    value: "select",
    label: "select",
  },
  {
    value: "multiselect",
    label: "multiselect",
  },
  {
    value: "checkbox",
    label: "checkbox",
  },
  {
    value: "colorpicker",
    label: "colorpicker",
  },
  {
    value: "file",
    label: "file",
  },
];

const formatColor = {
  hex: "hex",
};

const typeSample = (t) => [
  {
    label: `0 - ${t("Normal sample")}`,
    value: 0,
  },
  {
    label: `1 - ${t("Air Samples")}`,
    value: 1,
  },
];

const locationType = (t) => [
  {
    label: t(`Outpatient`),
    value: 0,
  },
  {
    label: t(`Inpatient`),
    value: 1,
  },
  {
    label: t("Send out"),
    value: 2,
  },
];

const optionTypeDate = (t) => [
  {
    label: `${t("Date of birth")}`,
    value: 0,
  },
  {
    label: `${t("Year of birth")}`,
    value: 1,
  },
];

const optionSex = (t) => [
  {
    label: `${t("Male")}`,
    value: "M",
  },
  {
    label: `${t("Female")}`,
    value: "F",
  },
];

const optionPayment = (t) => [
  {
    value: 1,
    label: `${t("Cash")}`,
  },
  {
    value: 2,
    label: `${t("Bank card")}`,
  },
  {
    value: 3,
    label: `${t("Credit card")}`,
  },
  {
    value: 4,
    label: `${t("Bank transfer")}`,
  },
];

const VALID_RESULT_PAGINATION_OPTIONS = (t) => [
  { value: 100, label: t("100records") },
  { value: 200, label: t("200records") },
  { value: 300, label: t("300records") },
  { value: 400, label: t("400records") },
  { value: 500, label: t("500records") },
  { value: 600, label: t("600records") },
  { value: 700, label: t("700records") },
  { value: 800, label: t("800records") },
  { value: 900, label: t("900records") },
  { value: 1000, label: t("1000records") },
];

const parameterCodeSelect = [
  {
    label: "Bác sĩ",
    value: "Doctor",
  },
  {
    label: "Loại mẫu",
    value: "TestType",
  },
  {
    label: "Nhóm XN",
    value: "Category",
  },
  {
    label: "Xét nghiệm",
    value: "Test",
  },
  {
    label: "Bộ XN",
    value: "Profile",
  },
  {
    label: "Khoa phòng",
    value: "Location",
  },
  {
    label: "Máy XN",
    value: "Instrument",
  },
  {
    label: "Khoa phòng tiếp nhận",
    value: "DepartmentReception",
  },
  {
    label: "Đối tượng",
    value: "Object",
  },
  {
    label: "Người dùng",
    value: "User",
  },
  {
    label: "Mức",
    value: "Level",
  },
  {
    label: "Lô",
    value: "Lottest",
  },
];

const parameterCode = {
  Doctor: "Doctor",
  Object: "Object",
  DepartmentReception: "DepartmentReception",
  Instrument: "Instrument",
  Location: "Location",
  Profile: "Profile",
  Test: "Test",
  Category: "Category",
  TestType: "TestType",
  Level: "Level",
  Lottest: "Lottest",
  User: "User",
};

export const defaultDateRange = {
  FROM: dayjs().startOf("day").subtract(10, "day"),
  TO: dayjs().endOf("day"),
};

const patientType = (t) => [
  {
    value: 99,
    label: t("All"),
  },
  {
    value: 0,
    label: t("Regular patient"),
  },
  {
    value: 2,
    label: t("EnvironmentSample"),
  },
  {
    value: 3,
    label: t("Urgent sample"),
  },
];

const TypeMethod = {
  "Thường quy": "Normal",
  "Vi sinh": "ViSinh",
};

const ReceptionType = (t) => [
  {
    label: "Tiếp nhận bằng mã phiếu",
    value: "ByOrderId",
  },
  {
    label: "Tiếp nhận bằng mã lượt chỉ định",
    value: "ByTurnCode",
  },
];

const ReceptionMethod = {
  "Tiếp nhận bằng số phiếu": 0,
  "Tiếp nhận bằng mã y tế": 1,
  "Tiếp nhận bằng khoa phòng": 2,
  "Tiếp nhận bằng số phiếu và mã lượt chỉ định": 3,
};

const MappingType = {
  TestCode: 0,
  Profile: 1,
  ViSinhSample: 2,
};

const StatusSample = (t) => [
  {
    value: 1,
    label: t("Đạt"),
  },
  {
    value: 2,
    label: t("Không đạt"),
  },
];

const StatusSampleText = {
  1: "Đạt",
  2: "Không đạt",
};

const ActionType = {
  ModifyInstrument: 1,
};

export {
  sequenceMode,
  sequenceModeText,
  sequenceComboBox,
  type,
  typeForm,
  formatColor,
  listSelectBase,
  typeSample,
  optionTypeDate,
  optionSex,
  optionPayment,
  VALID_RESULT_PAGINATION_OPTIONS,
  typeFormSelect,
  parameterCodeSelect,
  parameterCode,
  patientType,
  locationType,
  TypeMethod,
  ReceptionType,
  ReceptionMethod,
  MappingType,
  StatusSample,
  StatusSampleText,
  ActionType,
};
